export enum SortOrder {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum ReferenceType {
  Booking = 'Booking',
  MeetingWaitList = 'MeetingWaitList',
  Waitlist = 'Waitlist',
  VirtualBooking = 'VirtualBooking',
  Reservation = 'Reservation',
}

export enum ServiceOrderCategory {
  Catering = 'catering',
  TaskType = 'TaskType'
}

export enum SOReferenceType {
  Booking = 'Booking',
  Meeting = 'Meeting request',
  Catering = 'Catering only',
  MeetingWaitList = 'MeetingWaitList',
  Building = 'Building',
  Request='Request',
  Virtual='Virtual',
  ServiceOrder='ServiceOrder'
}

export enum SOReferenceTypeDashboard{
  Catering = 'Catering',
  MeetingWaitList = 'MeetingWaitList',
  Building='Building',
  booking='booking',
  request='request'
}

export enum CountryIds {
  US = 229,
  India = 95,
  Canada = 38,
  Chile = 43,
  Mexico=135
}


export enum Style {
  default = '',
  horizontal = 'horizontal',
  vertical = 'vertical'
}

export enum CounterStyle {
  default = '',
  withError = 'withError'
}